import React from 'react'
import Image from '~/components/atoms/Image'
import FindCta from '~/components/molecules/FindCta';
import RentalCta from '~/components/molecules/RentalCta';
import TextCard from '~/components/molecules/TextCard';
import HelpFeatures from '~/components/molecules/HelpFeatures';
import FadeInWhenVisible from '~/components/FadeInWhenVisible'
import HeroMultiPropertyOwner from './HeroMultiPropertyOwner';
import KPISection from '~/components/organisms/KPISection';
import './Hero.css';

export default function Hero({ key, index, ...props }) {
  const section = props.hero

  if (section.form === 'multi-property-owner-form') {
    return <HeroMultiPropertyOwner index={index} hero={section} />
  }

  const imagePosition = section.isHomepage ? "right" : "center";
  const videoUrl = section?.video?.localFile?.publicURL;

  return (
    <>
    <section
      id={section.fieldGroupName + index}
      className="mb-20 md:mb-36 md:h-screen md:max-h-[860px] relative text-white padding-container hero-section"
      style={{ marginBottom: section.isHomepage ? '0' : '' }}
    >

      <div className="absolute inset-0">
        {videoUrl ? (
          <video
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover"
          >
            <source src={videoUrl} type="video/mp4" />
          </video>
        ) : section?.image ? (
          <Image loading={'eager'} data={section.image} className="w-full h-full" imageClassName="w-full h-full" objectPosition={imagePosition} />
        ) : null}

        <div className="absolute inset-0 bg-navy opacity-10"></div>
        <div className="absolute inset-0 bottom-auto h-40 opacity-50 bg-gradient-to-b from-navy"></div>
        <div className="absolute inset-0 opacity-75 bg-gradient-to-r from-navy"></div>
      </div>

      {(section.form === 'Find Home' || section.form === 'Get Estimate') && (
        <div className="container py-32 pb-20 md:pb-0 md:py-0 h-full relative flex flex-col justify-center items-center">
          <div className="hero-section-copy">
            <TextCard {...section.textCard} alignText="center" />
          </div>

          {section.form && (
            <FadeInWhenVisible transition={{ delay: '.25' }} className="max-w-4xl">
              {section.form === 'Find Home' ? (
          <FindCta className="text-white" buttonText={section?.textCard?.buttons?.[0]?.button?.button?.button?.title} buttonUrl={section?.textCard?.buttons?.[0]?.button?.button?.button?.url}/>
              ) : section.form === 'Get Estimate' ? (
                <RentalCta isHero={true} editablePostcode={true} className="text-white" language={section.language ?? 'en'} />
              ) : null}
            </FadeInWhenVisible>
          )}

          {section.showHelpFeatures && (
            <HelpFeatures language={section.language ?? 'en'} />
          )}
        </div>
      )}
    </section>
    {section.isHomepage && <KPISection />}
    </>
  )
}